// Constants
import { COMPANY } from '@/constants/company'

export const getCompanyBrandName = (isOverseaUser: boolean) => {
  return !isOverseaUser ? COMPANY.TUTORABC_SHOP.BRAND_NAME : COMPANY.TUTORABC_GLOBAL.BRAND_NAME
}

export const getCompanyNameDefault = (isOverseaUser: boolean, t: any) => {
  return !isOverseaUser ? t(COMPANY.TUTORABC_SHOP.COMPANY_NAME.DEFAULT) : t(COMPANY.TUTORABC_GLOBAL.COMPANY_NAME.DEFAULT)
}

export const getCompanyNameEn = (isOverseaUser: boolean) => {
  return !isOverseaUser ? COMPANY.TUTORABC_SHOP.COMPANY_NAME.EN_US : COMPANY.TUTORABC_GLOBAL.COMPANY_NAME.EN_US
}
